<div class="content">
  <h3 class="title">¿Seguro que desea eliminar este archivo?</h3>
  <div class="buttons">
    <button mat-raised-button (click)="close(false)" class="cancel-btn rounded">
      Cancelar
    </button>
    <button mat-raised-button (click)="close(true)" class="primary-btn rounded">
      Confirmar
    </button>
  </div>
</div>
